import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ServiceOccupationActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ServiceOccupation/ServiceOccupationBrowser")
	}

	render() {
		return (
			<Activity 
				name="ServiceOccupation"
				RenderedComponent={this.RenderedComponent}
				context="ServiceOccupation"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ServiceOccupationActivity)
